import React from 'react';
import ReactDOM from 'react-dom';
import Mathjax from './Mathjax';

function getTooltip(tip) {
    if (typeof tip === "string") {
        return tip.split("\n").map(function (item, idx) {
            return (
                <span key={idx}>
                    {idx > 0 && <br />}
                    <Mathjax value={item} />
                </span>
            );
        });
    } else {
        return tip;
    }
}

export function ToolTipModal({ tip, offset, position, transform, theme }) {
    if (tip) {
        var pickerCss = {
            position: 'fixed',
            zIndex: '1000',
            maxWidth: '350px',
        };

        if (transform) {
            pickerCss.transform =
                transform === 'cy' ? 'translateY(-50%)' : 'translateX(-50%)';
        }

        switch (position) {
            case 'lt':
                pickerCss.right = window.innerWidth - offset.x;
                pickerCss.bottom = window.innerHeight - offset.y;
                break;
            case 'lb':
                pickerCss.right = window.innerWidth - offset.x;
                pickerCss.top = offset.y;
                break;
            case 'rt':
                pickerCss.left = offset.x;
                pickerCss.bottom = window.innerHeight - offset.y;
                break;
            case 'rb':
            default:
                pickerCss.left = offset.x;
                pickerCss.top = offset.y;
                break;
        }

        return (
            <div className={'tde-theme-' + theme} style={pickerCss}>
                <div className="tde-tooltip">
                    {getTooltip(tip)}
                </div>
            </div>
        );
    } else {
        return <div></div>;
    }
}

class ToolTip extends React.Component {
    componentDidMount() {
        this.wrapperElement = document.createElement('div');
        this.wrapperElement.setAttribute('class', 'tde-tooltip-wrapper');
        document.body.appendChild(this.wrapperElement);
    }
    componentWillUnmount() {
        this._safeUnmount(true);
    }

    renderToolTip = e => {
        const rect = e.target.getBoundingClientRect();
        let top;
        let left;
        let transform = 'cx';
        let position = 'rb';
        if (this.props.dir === 'r') {
            top = rect.y + rect.height / 2;
            left = rect.x + rect.width + 10;
            transform = 'cy';
        } else if (this.props.dir === 't') {
            top = rect.y - 10;
            left = rect.x + rect.width / 2;
            position = 'rt';
        } else {
            top = rect.y + rect.height + 10;
            left = rect.x + rect.width / 2;
        }

        const toolTipEle = React.createElement(ToolTipModal, {
            offset: {
                x: left,
                y: top,
            },
            transform,
            position: position,
            tip: this.props.tip,
            theme: this.props.Dyn.preferences.getTheme(),
        })

        clearTimeout( this.unmountTimeout );
        if(this.toolTipWrapperEleRoot ) {
            this.toolTipWrapperEleRoot.render(
                toolTipEle
            );
        } else {
            this.toolTipWrapperEleRoot = ReactDOM.createRoot(this.wrapperElement);
            this.toolTipWrapperEleRoot.render(
                toolTipEle
            );
        }
    }

    mouseEnter = e => {
      this.renderToolTip(e);
    };

    mouseLeave = () => {
        this._safeUnmount();
    };

    onBlur = () => {
        this._safeUnmount();
    };

    _safeUnmount = (canRemoveWrapperEle) => {
        // remove the tooltip, with time delay to avoid "warning:
        //      Attempted to synchronously unmount a root while React was already rendering.
        //      React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        this.unmountTimeout = setTimeout(() => {
            this.toolTipWrapperEleRoot?.unmount();
            this.toolTipWrapperEleRoot = null;
            if(canRemoveWrapperEle) {
                document.body.removeChild(this.wrapperElement);
            }
        });
    }

    onFocus = e => {
        this.renderToolTip(e);
    };

    onKeyDown = () => {
        if (event.keyCode === 27) { // ESC key
          event.preventDefault();
          this.onBlur()
        }
    }

    render() {
        // Enable tooltip only for touch devices
        if (this.props.Dyn && !this.props.Dyn.environment.isTouchDevice()) {
            const props = {
                onMouseEnter: this.mouseEnter,
                onMouseLeave: this.mouseLeave,
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                tabIndex: 0,
                onKeyDown:this.onKeyDown
            };
            if(this.props.follow) {
                props.onMouseMove = this.mouseEnter;
            }

            const children = React.cloneElement(this.props.children, props);
            return <React.Fragment>{children}</React.Fragment>;
        } else {
            return <React.Fragment>{this.props.children}</React.Fragment>;
        }
    }
}

export default ToolTip;
